import instance from "../../utils/axios";

const API_BASE_URL = "/churches/program/coverimage";

// ✅ Save Program Cover Image
export const saveProgramCoverImageApi = async (payload) => {
  const required = ["programObjId", "galleryObjId"];
  for (const key of required) {
    if (!payload[key]) throw new Error(`Missing field: ${key}`);
  }

  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([k, v]) => formData.append(k, v || ""));

  const response = await instance.post(`${API_BASE_URL}/save`, formData);
  return response.data; // { type, message, data }
};

// ✅ Update Program Cover Image
export const updateProgramCoverImageApi = async (payload) => {
  const required = ["programObjId", "galleryObjId"];
  for (const key of required) {
    if (!payload[key]) throw new Error(`Missing field: ${key}`);
  }

  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([k, v]) => formData.append(k, v || ""));

  const response = await instance.post(`${API_BASE_URL}/update`, formData);
  return response.data; // { type, message, data }
};
// ✅ DELETE PROGRAM COVER IMAGE
export const deleteProgramCoverImageApi = async (payload) => {

  const required = ["_id", "programObjId", "programcoverimageObjId"];
  required.forEach((key) => {
    if (!payload[key]) throw new Error(`Missing field: ${key}`);
  });

  const formData = new URLSearchParams();
  Object.entries(payload || {}).forEach(([k, v]) => formData.append(k, v || ""));

  const response = await instance.post(`${API_BASE_URL}/delete`, formData);
  return response.data; // { type, message, data }
};
